module.exports = __webpack_public_path__ + "static/img/yshh1-3-2.c7ccbdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/yshh1-3-2.jpg
// module id = 781
// module chunks = 0